import React from "react";
import PropTypes from "prop-types";
import { FormControl, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { get, has } from "lodash";
import { withStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const BogoInput = (props) => {
  const { classes, onChange, buyValue, getValue, touched, errors } = props;
  const { t } = useTranslation();
  const renderByType = (tempType) => {
    switch (tempType) {
      case "center":
        return (
          <Grid
            container
            direction="row"
            alignItems="center"
            rowSpacing={1}
            columnSpacing={2}
          >
            <Grid size={{ xs: 12, sm: 3 }}>
              <TextField
                id="buyValue"
                value={buyValue}
                fullWidth
                onChange={(event) => onChange(event.target.value, "buyValue")}
                error={get(touched, "buyValue") && has(errors, "buyValue")}
                helperText={get(touched, "buyValue") && get(errors, "buyValue")}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
              <Typography variant="caption">
                {t("offer_create.basic_b_g_one_template")}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
              <TextField
                id="getValue"
                value={getValue}
                fullWidth
                onChange={(event) => onChange(event.target.value, "getValue")}
                error={get(touched, "getValue") && has(errors, "getValue")}
                helperText={get(touched, "getValue") && get(errors, "getValue")}
              />
            </Grid>
          </Grid>
        );
      default:
        return (
          <Grid
            container
            direction="row"
            alignItems="center"
            rowSpacing={1}
            columnSpacing={2}
          >
            <Grid size={{ xs: 12, sm: 2 }}>
              <Typography variant="caption">
                {t("offer_create.basic_b_one_prefix")}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                id="buyValue"
                value={buyValue}
                fullWidth
                onChange={(event) => onChange(event.target.value, "buyValue")}
                error={get(touched, "buyValue") && has(errors, "buyValue")}
                helperText={get(touched, "buyValue") && get(errors, "buyValue")}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 2 }}>
              <Typography variant="caption">
                {t("offer_create.basic_g_one_prefix")}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                id="getValue"
                value={getValue}
                fullWidth
                onChange={(event) => onChange(event.target.value, "getValue")}
                error={get(touched, "getValue") && has(errors, "getValue")}
                helperText={get(touched, "getValue") && get(errors, "getValue")}
              />
            </Grid>
          </Grid>
        );
    }
  };

  return (
    <FormControl className={classes.formControl} fullWidth>
      <Typography className={classes.label}>
        {t("offer_create.basic_b_g_one_label")}
      </Typography>
      {renderByType(t("offer_create.basic_b_g_template_type"))}
    </FormControl>
  );
};

const styles = (theme) => ({
  label: {
    fontWeight: "bold",
  },
});

BogoInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  buyValue: PropTypes.string,
  getValue: PropTypes.string,
  touched: PropTypes.object,
  errors: PropTypes.object,
};

export default withStyles(styles)(BogoInput);
